import styles from "components/sections/search/SearchResult.module.scss";
import {useEffect, useState} from "react";
import AllSearchResult from "components/sections/search/AllSearchResult";
import StoreSearchResult from "components/sections/search/store/StoreSearchResult";
import BrandSearchResult from "components/sections/search/BrandSearchResult";
import PaletteSearchResult from "components/sections/search/PaletteSearchResult";
import SellerShopSearchResult from "components/sections/search/SellerShopSearchResult";
import {Axios} from "api";
import {captureException, captureMessage} from "@sentry/nextjs";
import MainBanner from "components/sections/MainBanner";
import {getLocalStorageCountryCode} from "common/utils";


export const KEY_ALL = 'all';
export const KEY_STORE = 'store';
export const KEY_BRAND = 'brand';
export const KEY_PALETTE = 'palette';
export const KEY_SELLER_SHOP = 'seller_shop';

export const KEY_TO_TAB_NAME = {
    [KEY_ALL]: '전체',
    [KEY_STORE]: '스토어',
    [KEY_BRAND]: '브랜드',
    [KEY_PALETTE]: '팔레트',
    [KEY_SELLER_SHOP]: '편집샵',
};

export const TAB_NAME_TO_CURATION_KEY = {
    [KEY_STORE]: 'search_recommended_query_store',
    [KEY_BRAND]: 'search_recommended_query_brand',
    [KEY_PALETTE]: 'search_recommended_query_palette',
    [KEY_SELLER_SHOP]: 'search_recommended_query_seller_shop',
};


const SearchResult = (props) => {
    const {searchText, setSearchText, activeTab, setActiveTab, close} = props;

    const [keyToRecommendQueries, setKeyToRecommendQueries] = useState({});
    const countryCode = getLocalStorageCountryCode()
    useEffect(() => {
        const tabKeys = Object.values(TAB_NAME_TO_CURATION_KEY).map((key) => {
            if(countryCode !== 'KR') {
                return key + `_${countryCode}`;
            }
            return key;
        })
        fetchSearchStats(tabKeys);
    }, []);

    const fetchSearchStats = async (tabKeys) => {
        try {
            const keyQuery = Object.values(TAB_NAME_TO_CURATION_KEY).join(',');
            const res = await Axios.get(`v1/curation-bulk/${tabKeys}`);
            if (res.status < 400) {
                const resDataCopy = JSON.parse(JSON.stringify(res.data.key_to_curation));
                for (const [_, curation] of Object.entries(resDataCopy)) {
                    curation.item_list = curation.item_list.map(e => ({value: e, rank: Math.random()})).sort(
                        (a, b) => a.rank - b.rank
                    ).map(e => e.value);
                }
                setKeyToRecommendQueries(resDataCopy);
            } else {
                captureMessage(JSON.stringify(res.data));
            }
        } catch (e) {
            captureException(e);
        } finally {
        }
    };

    const onItemClick = (item) => {
        close();
    }

    const getTabContent = () => {
        switch (activeTab) {
            case KEY_ALL:
                return <AllSearchResult
                    query={searchText} setQuery={setSearchText}
                    setActiveTab={setActiveTab}
                    onItemClick={onItemClick}
                />;
            case KEY_STORE:
                return <StoreSearchResult
                    query={searchText} setQuery={setSearchText}
                    recommendedQueries={
                        keyToRecommendQueries[TAB_NAME_TO_CURATION_KEY[KEY_STORE]]?.item_list || []
                    }
                    onItemClick={onItemClick}
                />;
            case KEY_BRAND:
                return <BrandSearchResult
                    query={searchText} setQuery={setSearchText}
                    recommendedQueries={
                        keyToRecommendQueries[TAB_NAME_TO_CURATION_KEY[KEY_BRAND]]?.item_list || []
                    }
                    onItemClick={onItemClick}
                />;
            case KEY_PALETTE:
                return <PaletteSearchResult
                    query={searchText} setQuery={setSearchText}
                    recommendedQueries={
                        keyToRecommendQueries[TAB_NAME_TO_CURATION_KEY[KEY_PALETTE]]?.item_list || []
                    }
                    onItemClick={onItemClick}
                />;
            case KEY_SELLER_SHOP:
                return <SellerShopSearchResult
                    query={searchText} setQuery={setSearchText}
                    recommendedQueries={
                        keyToRecommendQueries[TAB_NAME_TO_CURATION_KEY[KEY_SELLER_SHOP]]?.item_list || []
                    }
                    onItemClick={onItemClick}
                />;
        }
    };

    const [banners, setBanners] = useState([]);

    useEffect(async () => {
        try {
            const res = await Axios.get('v1/banners', {params: {location: 'search'}});
            if (res.status < 400) {
                setBanners(res.data.banners);
            }
        } catch (e) {
            captureException(e);
        }
    }, []);

    return (
        <>
            {
                getTabContent()
            }
            {
                !Boolean(searchText) && activeTab !== KEY_ALL && banners.length > 0 &&
                <div className={styles.bannerContainer}>
                    <MainBanner banners={banners} isLoading={false} />
                </div>
            }
        </>
    )
};

export default SearchResult;
